import { render } from "./TraderPayoutPlans.vue?vue&type=template&id=37a51774&ts=true"
import script from "./TraderPayoutPlans.vue?vue&type=script&lang=ts"
export * from "./TraderPayoutPlans.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__